<template>
  <v-container fluid v-if="fullLoaded">
    <v-alert
      :value="msg"
      type="error"
      dismissible
      transition="scale-transition"
      v-for="msg in message"
      :key="msg"
      >{{ msg }}</v-alert
    >
    
    <v-row justify-space-around row fill-height>
      <v-col cols="9" mr-4>
        <v-row>
          <v-col>
            <OrderDetail :order="order">
              <v-btn text :to="'/build/build/' + build.order_id + '/package-list'">
                <v-icon left>mdi-printer</v-icon>Package List
              </v-btn>
            </OrderDetail>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-card class="mb-4">
              <v-toolbar tabs flat color="secondary" dark>
                <v-icon left>mdi-clipboard-text</v-icon>
                <v-toolbar-title>Comments</v-toolbar-title>
              </v-toolbar>
              <v-card-text>
                <order-comment :orderId="build.order_id"></order-comment>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="3" md4>
        <BuildInfo :order="order" :build="build" @change="update" />
      </v-col>
    </v-row>

    <NewBuildView v-if="build.status_id == 'new'" v-model="order" />
    <BackorderedBuildView v-if="build.status_id == 'backordered'" v-model="order" />
    <PendingBuildView v-if="build.status_id == 'pending'" v-model="order" />
    <HandlingList v-if="build.status_id == 'handling' || build.status_id == 'shipped'" :build="build" />
    
  </v-container>
</template>

<script>

import OrderDetail from '../../components/build/OrderDetail.vue';
import BuildInfo from '../../components/build/Info.vue';

import OrderComment from "@components/orders/OrderComment.vue";

import { mapActions } from 'vuex';
import NewBuildView from '../../components/build/NewBuildView.vue';
import BackorderedBuildView from '../../components/build/BackorderedBuildView.vue';
import PendingBuildView from '../../components/build/PendingBuildView.vue';
import HandlingList from '../../components/build/HandlingList.vue';

export default {
  components: {
    OrderDetail,
    OrderComment,
    NewBuildView,
    BackorderedBuildView,
    PendingBuildView,
    HandlingList,
    BuildInfo
  },
  data: function() {
    return {
      items: [],
      tabs: null,
      build: null,
      order:null,
      buildId: null,
      message: null,
      types: ["woods", "irons", "wedges", "putters"],
      
      valid: null,
    };
  },
  mounted: function() {
    if (this.$route.params.id) {
      this.buildId = this.$route.params.id;
      this.getBuild(this.$route.params.id);
    } else {
      this.$route.push("/prescription");
    }
  },
  computed: {
    canMarkAsCompleted: function(){
      if(this.order.prescription){
        if(this.order.prescription.isMarkableToSent){
          return true;
        }else{
          return false;
        }
      }else{
        return true;
      }
    },
    fullLoaded: function() {
      return this.order && this.build;
    },
  },
  methods: {
    ...mapActions("build", {fetchBuild:'get', changeStatus:"changeStatus"}),
    ...mapActions("orders", {fetchOrder:'get'}),
    getBuild(id) {
      this.fetchBuild(id)
        .then((data) => {
          this.build = data.build
          this.getOrder(this.build.order_id);
        });
    },
    getOrder(id){
      this.fetchOrder({id, expand:'prescription'})
        .then((data) => {
          this.order = data;
        });
    },
    update() {
      this.getBuild(this.$route.params.id);
    },
    error(payload) {
      this.message = [];
      for (const field in payload) {
        if ({}.propertyIsEnumerable.call(payload, field)) {
          const msg = payload[field];
          this.message.push(msg[0]);
        }
      }
    },
    
  },
};
</script>

<style lang="less" scoped></style>
